// Sprint 5 T12-v2 (C10) — banner persistente para alergia anafilactica.
//
// Reglas clinicas no negociables:
//   - SIN boton cerrar. SIN forma de ocultar mientras la alergia este activa.
//   - role="alert" + aria-live="assertive" para que screen readers anuncien.
//   - sticky top-0 con z-index alto para que cubra header/banners de offline.
//   - shimmer + pulse para que sea imposible no verlo.
//   - Respeta prefers-reduced-motion (deshabilita animaciones manteniendo color).
//
// El emoji 🚨 es parte del diseno clinico (excepcion explicita a la regla
// no-emoji del proyecto): aporta hipervisibilidad para staff que escanea
// rapido en horas pico.

interface BannerAnafilacticoProps {
  alergeno: string
}

export default function BannerAnafilactico({ alergeno }: BannerAnafilacticoProps) {
  return (
    <>
      <style>{`
        @keyframes avante-anafilactico-shimmer {
          0%   { background-position: 0% 50%; }
          50%  { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        @keyframes avante-anafilactico-pulse {
          0%, 100% { box-shadow: 0 0 0 0 rgba(220, 38, 38, 0.7); }
          50%      { box-shadow: 0 0 18px 4px rgba(220, 38, 38, 0.9); }
        }
        .avante-anafilactico-banner {
          background: linear-gradient(90deg, #7f1d1d 0%, #b91c1c 50%, #7f1d1d 100%);
          background-size: 200% 100%;
          animation: avante-anafilactico-shimmer 3s ease-in-out infinite,
                     avante-anafilactico-pulse 2s ease-in-out infinite;
        }
        @media (prefers-reduced-motion: reduce) {
          .avante-anafilactico-banner {
            animation: none;
            background: #b91c1c;
          }
        }
      `}</style>
      <div
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        data-testid="banner-anafilactico"
        className="avante-anafilactico-banner sticky top-0 z-[100] text-white font-bold text-center py-3 px-4 border-b-2 border-red-900 shadow-lg"
      >
        <span className="text-base sm:text-lg tracking-wide">
          {/* Emoji intencional — parte del diseno clinico de hipervisibilidad. */}
          🚨 ALERGIA ANAFILACTICA: {alergeno} — declarada por paciente
        </span>
      </div>
    </>
  )
}
